export default __webpack_public_path__ + "images/Asian.d9f255.jpg";